import React from "react";

/* eslint-disable max-len */
export default function ShareButton() {
    return (
        <svg version="1.1" id="icon" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
			viewBox="0 0 24 24" enableBackground="new 0 0 24 24" xmlSpace="preserve">
		<g>
			<path fill="none" d="M0,0h24v24H0V0z"/>
			<path fill="#101820" d="M16,5l-1.4,1.4L13,4.8V16h-2V4.8L9.4,6.4L8,5l4-4L16,5z M20,10v11c0,1.1-0.9,2-2,2H6c-1.1,0-2-0.9-2-2V10
				c0-1.1,0.9-2,2-2h3v2H6v11h12V10h-3V8h3C19.1,8,20,8.9,20,10z"/>
		</g>
		</svg>
    );
}
